<template>
    <section id="landing" class="landing-layout" :class="[
      isHome ? 'is-home' : '',
      isHeaderHidden ? 'header-hidden' : '',
      isSideMenuOpen ? 'side-menu-open' : '',
      hasOverlays ? 'has-overlays' : ''
    ]">
        <landing-header />
        <div class="view-wrapper">
            <transition :name="transition" mode="in-out">
                <router-view class="view">
                    <slot />
                </router-view>
            </transition>
        </div>
        <landing-footer />
        <side-menu />
        <sitemap-overlay />
        <wechat-overlay />
    </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  import LandingFooter from '@/components/widgets/LandingFooter'
  import LandingHeader from '@/components/widgets/LandingHeader'
  import SideMenu from '@/components/widgets/SideMenu'
  import SitemapOverlay from '@/components/widgets/Overlays/SitemapOverlay'
  import WechatOverlay from '@/components/widgets/Overlays/WechatOverlay'

  export default {
    data () {
      return {
        transition: 'view-slide'
      }
    },
    computed: {
      ...mapState({
        isHeaderHidden: (state) => state.landingHeader.isHidden,
        isSideMenuOpen: (state) => state.sideMenu.isOpen
      }),
      ...mapGetters([
        'isHome',
        'hasOverlays'
      ])
    },
    components: {
      LandingFooter,
      LandingHeader,
      SideMenu,
      SitemapOverlay,
      WechatOverlay
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-layout {
        width: 100%;
        overflow-x: hidden;

        .view-wrapper {
            position: relative;
        }

        .view {
            background-color: $body-bg;
            width: 100%;

            &-slide-enter {
                &-active {
                    position: absolute;
                    left: 100%;
                    top: 0;
                    transition: left .5s ease-in-out;
                }
                &-to {
                    left: 0;
                }
            }

            &-slide-leave {
                &-active {
                    position: absolute;
                    z-index: -1;
                }
            }
        }

        &::after {
            background-color: rgba(0,0,0,0.3);
            content: '';
            height: 0;
            position: fixed;
            opacity: 0;
            right: 0;
            top: 0;
            width: 0;
            z-index: 110;
            transition: opacity .5s ease-in-out, width .1s .5s, height .1s .5s;

            @include media-breakpoint-up(xl) {
                z-index: 10;
            }
        }

        &.side-menu-open::after {
            opacity: 1;
            width: 100%;
            height: 100%;
            transition: opacity .5s ease-in-out;
        }
    }
</style>


// WEBPACK FOOTER //
// Landing.vue?80107b08